module.exports = __webpack_public_path__ + "static/media/mauritius-shipping-map.ea5adda1.jpg";